/* eslint-disable camelcase */
import { biService } from '@wix/branding-logo-client/exports/biService';

export class welcomePageBiReporter {
  constructor() {
    biService.initSessionId({ screenName: 'welcomePage' });
  }

  _log(eventName, params = {}) {
    try {
      biService.biLogSafe(biLog => {
        biLog(eventName, { origin: 'WelcomePage', ...params });
      });
    } catch (error) {
      console.error(`[welcomePageController.js:sendBi] error`, error.message);
    }
  }

  _reportGoToOnboardingFromSplit() {
    this._log('arenaSplitPageLogoClick');
  }

  _reportGoToOnboardingFromNonSplit() {
    this._log('stGetStarted');
  }

  reportGoToOnboarding(isSplitPage) {
    if (isSplitPage) {
      this._reportGoToOnboardingFromSplit();
    } else {
      this._reportGoToOnboardingFromNonSplit();
    }
  }

  reportGoToArena() {
    this._log('arenaSplitPageArenaClick');
  }

  reportLogoPageView(previousPage) {
    this._log('logoPageView', { origin: 'no', previousPage });
  }
}
